/* AMPD Product Promotion: add-to-cart hook + countdown.

   Standalone from bundle-upgrade.js by design - the promo card is where
   experiments happen and the pack list should never be affected by them.

   Add to cart: ticking the box is a selection only. When the main product form
   fires on:cart:add, the ticked promo variant is added to the cart alongside
   the product and the cart drawer is refreshed. The discount itself (e.g. a
   Buy X Get Y automatic discount) is applied by Shopify in the cart; nothing
   here changes prices.

   Countdown: reads the end time from data-ends (ms since epoch, rendered by
   Liquid from the "ends" setting) and ticks down days / hours / minutes /
   seconds. At zero it hides the timer and the whole card, so an expired offer
   can't keep advertising itself until the next page load. */
(function () {
  /* ---------- add to cart ---------- */
  function selectedIds() {
    var ids = [];
    document.querySelectorAll('[data-ampd-promo-add]:checked').forEach(function (cb) {
      if (!cb.disabled && !cb.dataset.unavailable && cb.dataset.variantId) ids.push(Number(cb.dataset.variantId));
    });
    return ids;
  }

  var busy = false;
  function onMainAdd(e) {
    var pf = e.target && e.target.closest ? e.target.closest('product-form') : null;
    if (!pf || pf.closest('quick-add-drawer')) return;
    var ids = selectedIds();
    if (!ids.length || busy) return;
    busy = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
    })
      .then(function () { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')); })
      .catch(function () {})
      .finally(function () { busy = false; });
  }
  document.addEventListener('on:cart:add', onMainAdd);
  document.addEventListener('on:line-item:change', onMainAdd);

  /* ---------- countdown ---------- */
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function startTimer(card) {
    var ends = Number(card.getAttribute('data-ends'));
    var timer = card.querySelector('[data-ampd-promo-timer]');
    if (!ends || !timer) return;

    var d = timer.querySelector('[data-unit="d"]');
    var h = timer.querySelector('[data-unit="h"]');
    var m = timer.querySelector('[data-unit="m"]');
    var s = timer.querySelector('[data-unit="s"]');
    var wrap = card.closest('.ampd-promo-wrap') || card;

    function tick() {
      var left = ends - Date.now();
      if (left <= 0) {
        // Offer over: take the whole card away rather than show 00:00:00:00
        // next to "FREE", which would read as a live offer that doesn't work.
        wrap.hidden = true;
        clearInterval(iv);
        return;
      }
      var sec = Math.floor(left / 1000);
      var days = Math.floor(sec / 86400); sec -= days * 86400;
      var hrs = Math.floor(sec / 3600); sec -= hrs * 3600;
      var mins = Math.floor(sec / 60); sec -= mins * 60;
      d.textContent = String(days);
      h.textContent = pad(hrs);
      m.textContent = pad(mins);
      s.textContent = pad(sec);
    }
    tick();
    var iv = setInterval(tick, 1000);
  }

  /* ---------- smooth height open / close ---------- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function slide(el, show) {
    if (el._slideEnd) { el.removeEventListener('transitionend', el._slideEnd); el._slideEnd = null; }
    if (reduceMotion) { el.hidden = !show; el.classList.toggle('is-collapsed', !show); el.style.height = ''; return; }
    var from;
    if (show) {
      if (!el.hidden && !el.classList.contains('is-collapsed')) return;
      from = el.hidden ? 0 : el.offsetHeight;
      el.hidden = false;
      el.style.transition = 'none';
      el.style.height = 'auto';
      var to = el.scrollHeight;
      el.style.height = from + 'px';
      el.classList.add('is-collapsed');
      el.offsetHeight; // commit start state
      el.style.transition = 'height 0.3s cubic-bezier(0.2, 0.7, 0.2, 1)';
      el.classList.remove('is-collapsed');
      el.style.height = to + 'px';
    } else {
      if (el.hidden) return;
      from = el.offsetHeight;
      el.style.transition = 'none';
      el.style.height = from + 'px';
      el.offsetHeight;
      el.style.transition = 'height 0.25s cubic-bezier(0.4, 0, 0.2, 1)';
      el.classList.add('is-collapsed');
      el.style.height = '0px';
    }
    el._slideEnd = function (e) {
      if (e.target !== el || e.propertyName !== 'height') return;
      el.removeEventListener('transitionend', el._slideEnd); el._slideEnd = null;
      el.style.transition = ''; el.style.height = '';
      if (!show) el.hidden = true;
    };
    el.addEventListener('transitionend', el._slideEnd);
  }

  /* ---------- option pickers ---------- */
  function initPicker(card) {
    var opts = card.querySelector('[data-ampd-promo-opts]');
    var json = card.querySelector('[data-ampd-promo-variants]');
    var cb = card.querySelector('[data-ampd-promo-add]');
    if (!opts || !json || !cb) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    var selects = [].slice.call(opts.querySelectorAll('[data-ampd-promo-option]'));
    var msg = opts.querySelector('[data-ampd-promo-msg]');
    var img = card.querySelector('.ampd-promo__img');

    function current() {
      var chosen = [];
      selects.forEach(function (s) { chosen[Number(s.dataset.ampdPromoOption)] = s.value; });
      return chosen;
    }
    function match(chosen) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return chosen[i] === undefined || chosen[i] === o; });
      })[0];
    }
    function refresh() {
      var chosen = current();
      // Grey out values that are sold out with the other current choices.
      selects.forEach(function (s) {
        var idx = Number(s.dataset.ampdPromoOption);
        [].forEach.call(s.options, function (o) {
          var test = chosen.slice(); test[idx] = o.value;
          var v = match(test);
          var ok = !!(v && v.available);
          o.disabled = !ok;
          o.textContent = o.value;
        });
      });
      var v = match(chosen);
      var ok = !!(v && v.available);
      if (v) cb.dataset.variantId = v.id;
      cb.dataset.unavailable = ok ? '' : '1';
      if (msg) msg.hidden = ok;
      if (ok && v.image && img) { img.src = v.image; img.removeAttribute('srcset'); }
      if (typeof drops !== 'undefined') drops.forEach(function (d) { d.sync(); });
    }
    /* Custom dropdowns. Native <select> pop-ups are drawn by the phone's OS,
       which positioned them off the card on mobile and can't be styled. The
       real <select> stays (hidden) as the source of truth. */
    var drops = selects.map(function (s) {
      s.classList.add('ampd-promo__select--native');
      s.tabIndex = -1;
      s.setAttribute('aria-hidden', 'true');
      var dd = document.createElement('div');
      dd.className = 'ampd-promo__dd';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ampd-promo__dd-btn';
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');
      var lab = opts.querySelector('label[for="' + s.id + '"]');
      if (lab) { btn.id = s.id + '-btn'; lab.setAttribute('for', btn.id); btn.setAttribute('aria-label', lab.textContent); }
      var list = document.createElement('ul');
      list.className = 'ampd-promo__dd-list';
      list.setAttribute('role', 'listbox');
      var panel = document.createElement('div');
      panel.className = 'ampd-promo__dd-panel';
      panel.hidden = true;
      panel.appendChild(list);
      dd.appendChild(btn); dd.appendChild(panel);
      s.parentNode.insertBefore(dd, s.nextSibling);

      var isOpen = false;
      function close() { if (!isOpen) return; isOpen = false; slide(panel, false); dd.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
      function open() {
        drops.forEach(function (d) { if (d.close !== close) d.close(); });
        isOpen = true; slide(panel, true); dd.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true');
      }
      btn.addEventListener('click', function (e) { e.preventDefault(); isOpen ? close() : open(); });
      btn.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      list.addEventListener('click', function (e) {
        var li = e.target.closest('li');
        if (!li || li.getAttribute('aria-disabled') === 'true') return;
        s.value = li.dataset.value;
        close();
        s.dispatchEvent(new Event('change'));
        btn.focus();
      });
      function sync() {
        btn.innerHTML = '';
        var t = document.createElement('span'); t.textContent = s.value; btn.appendChild(t);
        list.innerHTML = '';
        [].forEach.call(s.options, function (o) {
          var li = document.createElement('li');
          li.setAttribute('role', 'option');
          li.dataset.value = o.value;
          li.setAttribute('aria-selected', o.value === s.value ? 'true' : 'false');
          if (o.disabled) li.setAttribute('aria-disabled', 'true');
          li.innerHTML = '<span></span>' + (o.disabled ? '<em>Sold out</em>' : '');
          li.firstChild.textContent = o.value;
          list.appendChild(li);
        });
      }
      return { close: close, sync: sync, el: dd };
    });
    document.addEventListener('click', function (e) {
      drops.forEach(function (d) { if (!d.el.contains(e.target)) d.close(); });
    });

    selects.forEach(function (s) { s.addEventListener('change', refresh); });
    refresh();

    // Reveal / hide the pickers with the tick box.
    var reveal = card.querySelector('[data-ampd-promo-reveal]');
    if (reveal) {
      cb.addEventListener('change', function () {
        if (!cb.checked) drops.forEach(function (d) { d.close(); });
        slide(reveal, cb.checked);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-ampd-promo][data-ends]').forEach(startTimer);
    document.querySelectorAll('[data-ampd-promo].ampd-promo--pick').forEach(initPicker);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
